import { payload } from "../../../../../node_modules/.pnpm/@sveltejs+kit@3.0.1_@opentelemetry+api@1.9.1_@sveltejs+vite-plugin-svelte@7.3.1_svelte@_066f7245ed4535775acaa01efb3c1fb7/node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_API_HOST = "https://dev3-api.ableysafesystem.com/";
export const PUBLIC_AI_CHAT_API_URL = "https://devai.ableysafesystem.com";
export const PUBLIC_AI_MAPCHAT_ENABLED = "true";
export const PUBLIC_BASEMAP_NO_ROADS = "https://api.maptiler.com/maps/0196d70d-7733-70b8-a25a-f7f3a21a1258/style.json";
export const PUBLIC_BASEMAP_FULL = "https://api.maptiler.com/maps/0196d710-ea92-73f4-88f0-52304d472f18/style.json";
export const PUBLIC_CONTEXT_LAYER_ID = "basemap_roads";
export const PUBLIC_DEV_USE_PROXY = "false";
export const PUBLIC_ENVIRONMENT = "development";
export const PUBLIC_GA_TRACKING_ID = "G-ZHKPNJQ40Q";
export const PUBLIC_HALO_LINK = "https://abley.haloitsm.com/portal/anonymousticket?tickettype_id=76&key=c8dae3cc-5753-4098-b8af-7341bf41b028";
export const PUBLIC_ISSUE_REPORTER_ENABLED = "true";
export const PUBLIC_LOGGING_MINLEVEL = "debug";
export const PUBLIC_MAPTILER_KEY = "7fBcYvXreZ15nhb2rkcX";
export const PUBLIC_PACKAGE_VERSION = "1.1.35";
export const PUBLIC_BUILD_SHA = "";
export const PUBLIC_SATELLITE_BASEMAP = "https://api.maptiler.com/tiles/satellite-v2/tiles.json";
export const PUBLIC_YEAR_COPYRIGHT_START = "2023";
export const PUBLIC_SENTRY_PROJECT_ID = "4511330274770944";
export const PUBLIC_PACKAGE_NAME = "abley-spatial-platform";
export const PUBLIC_SENTRY_ENABLED = "false";
export const PUBLIC_SENTRY_KEY = "539a41636add29aa8bcf3b46374c7b5e";
export const PUBLIC_SENTRY_PROFILES_SAMPLE_RATE = "0.1";
export const PUBLIC_SENTRY_ORG_ID = "o4505836144033792";
export const PUBLIC_SENTRY_TRACES_SAMPLE_RATE = "0.5";
export const PUBLIC_SENTRY_TRACE_PROPAGATION_ENABLED = "true";
